import { useEffect, useId } from 'react';

/**
 * Unsaved-edit registry (Section 14): editors report whether they hold a draft. Detail drawers refuse
 * to close while any draft exists, and leaving the page asks the browser to confirm.
 */
const dirty = new Set<string>();

export function hasUnsavedChanges(): boolean {
  return dirty.size > 0;
}

export function useUnsavedChanges(isDirty: boolean): void {
  const id = useId();
  useEffect(() => {
    if (isDirty) dirty.add(id);
    else dirty.delete(id);
    return () => {
      dirty.delete(id);
    };
  }, [id, isDirty]);
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', (event) => {
    if (dirty.size) event.preventDefault();
  });
}
